/** App-level popups do not inherit the external Salt player's dock palette.
 * Keep normal pages on the shell tokens and use the dock's full-page endpoint
 * while the player is presented, without changing the application's theme. */
export function saltDialogSurfaceStyle(immersive: boolean, material: string): Record<string, string> {
  if (!immersive) return {};
  const mica = material === 'mica';
  return {
    colorScheme: 'dark',
    '--salt-text': '#fff',
    '--salt-subtext': '#ffffffa6',
    '--salt-accent': '#fff',
    '--salt-on-accent': '#1e1715',
    '--salt-popup': '#292929',
    '--salt-background': '#202020',
    '--salt-sub-background': '#ffffff08',
    '--salt-stroke': '#ffffff12',
    '--salt-hover': '#ffffff1a',
    '--salt-hover-overlay': '#ffffff1a',
    '--salt-press-overlay': '#ffffff33',
    '--salt-subtle-background': '#ffffff14',
    '--salt-disabled-content': '#e1e6eb69',
    '--salt-disabled-subtle-background': '#e1e6eb0d',
    '--salt-selection': '#ffffff1a',
    '--salt-error': '#ff99a4',
    '--salt-warning': '#fce100',
    '--salt-sub-surface-fallback': material === 'none' ? '#292929' : mica ? '#202020' : '#2c2c2c',
    '--salt-sub-surface-color': mica ? 'rgb(32 32 32 / .8)' : 'rgb(44 44 44 / .15)',
    '--salt-sub-surface-luminosity': mica ? '#202020' : 'rgb(44 44 44 / .96)',
    '--color-text': '#fff',
    '--color-secondary': '#ffffffa6',
    '--color-primary': '#fff',
    '--color-primary-bg': '#ffffff1a',
    '--color-body-bg': '#292929',
    '--color-secondary-bg': '#ffffff08',
  };
}
